import {
  useMutateItem,
  useGetListItems,
  useMutateItemWithUpload,
} from '../../../hooks/entityMethodsHook'

export const useMutateWorkerRegister = (key: string) => {
  const uri = `users/register-worker`
  return useMutateItemWithUpload(key, uri)
}

export const useGetEmailExists = (key: string, email: string) => {
  const uri = `users/email-exists?email=${email}`
  return useGetListItems(key, uri, !!email)
}

export const useGetIdNumberExists = (key: string, idNumber: string) => {
  const uri = `users/id-number-exists?idNumber=${idNumber}`
  return useGetListItems(key, uri, !!idNumber)
}
